<template>
    <div class="share" v-if="Array.isArray(result)" >
        <span class="share__item" v-for="item in result" @click="shareOpen(item)">
            <svg>
                <use :xlink:href="`#svg-${item.code}`"></use>
            </svg>
        </span>
    </div>
</template>

<script>
  export default {
      name: 'share',
      selector: '.share',
      props: {
          result: {
              type: Array,
              default: () => ([
                  {
                      code: 'facebook',
                      url: 'some_url'
                  },
                  {
                      code: 'telegram',
                      url: 'some_url'
                  },
                  {
                      code: 'twitter',
                      url: 'some_url'
                  },
                  {
                      code: 'vkontakte',
                      url: 'some_url'
                  },
                  {
                      code: 'linkedin',
                      url: 'some_url'
                  },
                  {
                      code: 'pinterest',
                      url: 'some_url'
                  },
                  {
                      code: 'tumblr',
                      url: 'some_url'
                  },
                  {
                      code: 'reddit',
                      url: 'some_url'
                  },
                  {
                      code: 'skype',
                      url: 'some_url'
                  },
                  {
                      code: 'viber',
                      url: 'some_url'
                  },
                  {
                      code: 'whatsapp',
                      url: 'some_url'
                  },
              ])
          }
      },
      data() {
          return {
              shareUrl: {
                  facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
                  telegram: 'https://telegram.me/share/url?url=',
                  twitter: 'https://twitter.com/home?status=',
                  vkontakte: 'http://vkontakte.ru/share.php?url=',
                  linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=',
                  pinterest: 'https://pinterest.com/pin/create/button/?url=',
                  tumblr: 'https://www.tumblr.com/widgets/share/tool?canonicalUrl=',
                  reddit: 'https://reddit.com/submit?url=',
                  skype: 'https://web.skype.com/share?url=',
                  viber: 'https://viber.com/share?url=',
                  whatsapp: 'whatsapp://send?text=',
              }
          }
      },
      methods: {
          shareOpen({code, url}) {
              try {
                  const vw = window.innerWidth / 2;
                  const vh = window.innerHeight / 2;

                  const left = (window.innerWidth - vw) / 2;
                  const top = (window.innerHeight - vh) / 2;

                  const params = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height='+ vh +',width='+ vw +',left='+ left +',top='+ top;

                  if (code in this.shareUrl && url !== '') {
                      window.open(
                          this.shareUrl[code] + url,
                          '', params
                      );
                  } else {
                      console.error(`we don't have url for this share: ${code}`);
                  }
              } catch (err) {
                  console.error(err);
              }
          }
      }
  }
</script>

<style lang="scss" scoped>
    .share{
        &__item{
            &:not(:last-child) {
                margin-right: 15px;
            }
            &:hover{
                cursor: pointer;
            }
            svg{
                width: 20px;
                height: 20px;
            }
        }
    }
</style>